import { CompanyMineContent } from "../../features/companyWorkspace";

function CompanyMineScreen() {
  return <CompanyMineContent />;
}

export default CompanyMineScreen;
